import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom"
import App from "./App";
import { BodyPage } from "./Pages/BillingPage/bodyPage";
import { ConfgOffline } from "./Pages/ConfgOffline/confgOffline";
import { About } from "./Pages/About/About";
import { ConfgOnline } from "./Pages/ConfgOnline/confgOnline";
import { LogoPage } from "./Pages/Logo/LogoPage";

const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/logo",
        element: <LogoPage />
      },
      {
        path: "/home",
        element: <BodyPage />
      },

      {
        path: "/ConfgOnline",
        element: <ConfgOnline />
      },

      {
        path: "/ConfgOffline",
        element: <ConfgOffline />
      },

      {
        path: "/About",
        element: <About />
      },

      {
        index: true,
        element: <Navigate to="/logo" replace /> // Redireciona para /logo
      },
    ]
  },
])

export default function MainRoutes() {
  return (
    <RouterProvider router={router} />
  )
}